module.exports = {"id":"187533","name":"Alexey Ionov","rating":"73","photo":"./data/images/photos/1/187533.png","club":{"name":"FK Rostov","logo":"./data/images/clubs/FKRostov.png"},"positions":["MD","MG","BU"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlexeyIonov0.json
// module id = 267
// module chunks = 0